// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"5e573bdd","82":"8fb3625b","351":"fc9c1f69","426":"a48d0e87"}[chunkId] + ".chunk.css";
};